import React from "react";
import BookingForm from "./BookingForm";
import { RESIDENTIAL_OFFER } from "../lib/offer";

// Offer header shown directly above every residential booking form.
export const OfferHeader = ({ testIdPrefix = "offer", as: Tag = "h3", className = "mb-6" }) => (
  <div className={className} data-testid={`${testIdPrefix}-offer`}>
    <Tag className="text-2xl lg:text-3xl font-extrabold text-slate-900 leading-tight" style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 800 }} data-testid={`${testIdPrefix}-offer-headline`}>
      {RESIDENTIAL_OFFER.headline}
    </Tag>
    <p className="text-sm text-slate-600 mt-1.5" data-testid={`${testIdPrefix}-offer-subtext`}>{RESIDENTIAL_OFFER.subtext}</p>
    <p className="text-sm text-slate-600 mt-1.5" data-testid={`${testIdPrefix}-on-the-way-note`}>You'll get a confirmation before your appointment, and a text when your technician is on the way.</p>
  </div>
);

// Card wrapper that matches the /contact page form panel — used on every landing page.
const EmbeddedLeadForm = ({ testIdPrefix = "embedded-lead", cityContext, serviceContext }) => (
  <div className="bg-white rounded-3xl p-8 lg:p-10 shadow-xl border border-slate-100" data-testid={`${testIdPrefix}-card`}>
    <OfferHeader testIdPrefix={testIdPrefix} />
    <BookingForm testIdPrefix={testIdPrefix} cityContext={cityContext} serviceContext={serviceContext} leadType="booking" leadValue={89} />
  </div>
);

export default EmbeddedLeadForm;
